import { Component, OnInit } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { IDialogResult } from 'src/app/models/base.model';
import { ConferenceResource, IConferenceCurrent } from 'src/app/models/iconference.interface';
import { ConferenceService } from 'src/app/services/data/conference.service';

@Component({
  selector: 'app-select-conference-dialog',
  templateUrl: './select-conference-dialog.component.html',
  styleUrls: ['./select-conference-dialog.component.css']
})
export class SelectConferenceDialogComponent implements OnInit {

  items$: Observable<IConferenceCurrent[]> = this.srv.getAll().pipe(
    map((data: ConferenceResource[]) => this.order.transform(data, "dateStart", true).map(r => ({
      id: r.id,
      name: `${r.name} (${r.cityName ?? ''}, ${r.dateStart.split('T')[0]})`,
      alias: r.alias
    } as IConferenceCurrent))),
    shareReplay()
  );

  selected: IConferenceCurrent | undefined;


  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private srv: ConferenceService,
    private order: OrderPipe
  ) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.ref.close({ submitted: false, data: null } as IDialogResult);
  }

  onSubmit() {
    this.ref.close({ submitted: true, data: this.selected.id } as IDialogResult);
  }

}

export class SelectConferenceDialogModel {
  constructor(
    public conferenceId: number | undefined
  ) {}
}

export class SelectConferenceDialogResult implements IDialogResult {
  constructor(public submitted: boolean, public data: number) {}
}
